import { RadioGroup } from "@headlessui/react"
import React from "react"

interface RadioPopoverButtonProps {
  checked: boolean
  option: any
}

const RadioPopoverButton: React.FC<RadioPopoverButtonProps> = ({
  checked,
  option,
}) => (
  <div className="flex flex-col items-center justify-center">
    <div className="flex flex-col">
      <RadioGroup.Label as="p" className="inline-flex items-center mt-3">
        {/* Checked styling in src/assets/vendor/_index.scss */}
        <input
          type="radio"
          className="w-5 h-5 border-2 form-radio bg-gray-80 text-gray-70 checked:text-blue-50"
          defaultChecked={checked}
        />
        <RadioGroup.Description
          as="span"
          className="ml-6 text-gray-2.5 caption1"
        >
          {option}
        </RadioGroup.Description>
      </RadioGroup.Label>
    </div>
  </div>
)

interface RadioButtonsProps {
  close: () // focusableElement?:
  //   | HTMLElement
  //   | React.MutableRefObject<HTMLElement | null>
  //   | undefined
  => void
  onSelected: (selected: string | null | number) => void
  selected: number | string | null
  options: any[]
  title?: string
}

const RadioButtons: React.FC<RadioButtonsProps> = ({
  close,
  selected,
  onSelected,
  options,
  title = "Content Type",
}) => {
  let selectedValue: string | number | null = selected

  if (selected === null && options.length > 0) {
    selectedValue = options[0].name ?? null
  }

  const radioGroupChanged = (node: string | null | number) => {
    close()
    if (node) {
      onSelected(node)
    }
  }
  return (
    <div className="w-full max-w-md p-4">
      <span className="caption2 text-gray-30">{title}</span>
      <RadioGroup<"div", string | number | null>
        className="mt-4"
        value={selectedValue}
        onChange={radioGroupChanged}
      >
        <RadioGroup.Label className="sr-only">{title}</RadioGroup.Label>
        <div className="bg-gray-90">
          {options.map(
            ({ name, slug }) =>
              name &&
              slug && (
                <RadioGroup.Option
                  key={slug}
                  value={slug}
                  className="relative flex rounded-lg cursor-pointer focus:outline-none"
                >
                  {({ checked }) => (
                    <RadioPopoverButton checked={checked} option={name} />
                  )}
                </RadioGroup.Option>
              ),
          )}
        </div>
      </RadioGroup>
    </div>
  )
}

export default RadioButtons
